import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MenuVisibilityMap } from './menu.types';
import { AppConfig } from '../../services/config.service';

@Injectable({ providedIn: 'root' })
export class MenuVisibilityApiService {
  private base =
    (AppConfig?.settings?.backend?.url || '/api/') + 'Authorization/';

  constructor(private http: HttpClient) {}

  getVisibility(): Observable<MenuVisibilityMap> {
    return this.http.get<MenuVisibilityMap>(`${this.base}visibility`);
  }

  updateVisibility(newMap: MenuVisibilityMap): Observable<void> {
    return this.http.post<void>(`${this.base}visibility`, newMap);
  }
}
